import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  // {
  //   path: 'login',
  //   loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  // },
  {
    path: 'masters',
    loadChildren: () => import('./modules/masters/masters.module').then(m => m.MastersModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/all-files/all-files.module').then(m => m.AllFilesModule)
  },
  {
    path: 'tags',
    loadChildren: () => import('./modules/tags/tags.module').then(m => m.TagsModule)
  },
  {
    path: 'trash',
    loadChildren: () => import('./modules/trash/trash.module').then(m => m.TrashModule)
  },
  {
    path: 'my-files',
    loadChildren: () => import('./modules/my-files/my-files.module').then(m => m.MyFilesModule)
  },
  {
    path: 'tag-document/:id',
    loadChildren: () => import('./modules/tag-document/tag-document.module').then(m => m.TagDocumentModule)
  },
  {
    path: 'favorites',
    loadChildren: () => import('./modules/favorites/favorites.module').then(m => m.FavoritesModule)
  },
  {
    path: 'recent-activity',
    loadChildren: () => import('./modules/recent-activity/recent-activity.module').then(m => m.RecentActivityModule)
  },
  {
    path: 'recent-activity',
    loadChildren: () => import('./modules/recent-activity/recent-activity.module').then(m => m.RecentActivityModule)
  },
  {
    path: 'shared-document',
    loadChildren: () => import('./modules/shared-table/shared-table.module').then(m => m.SharedTableModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
